module.exports = __webpack_public_path__ + "06_face.27de78b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/06_face.png
// module id = 4213
// module chunks = 0